import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ActionType,
  IFactorsNEffectsPayload,
  IFactorsNEffectsResponse,
} from "models/stressCheck/factorsNEffects";
import { httpStatus } from "configs/httpStatus";
import { getFactorsnEffects } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./factorsNEffectsActions";

function* getFactorsNEffectsSaga({
  payload,
}: {
  payload: IFactorsNEffectsPayload;
}) {
  try {
    const response: IFactorsNEffectsResponse = yield call(
      getFactorsnEffects,
      payload
    );

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetFactorsNEffectsWatcher() {
  yield takeLatest(ActionType.FACTOR_N_EFFECTS as any, getFactorsNEffectsSaga);
}

export default [fork(onGetFactorsNEffectsWatcher)];
